import PlayOutline from './PlayOutline'

export default PlayOutline
// eslint-disable-next-line import/export
export * from './PlayOutline'
